import React, { useState, useRef, useEffect } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const ClientSearchField = props => {
  const { delay, value, onChange, onClickPowerSearch, showClearWhenEmpty, onClearFiltered, ...rest } = props;
  const [internalValue, setInternalValue] = useState(value);
  const valueRef = useRef(value);

  useEffect(() => {
    setInternalValue(value);
    valueRef.current = value;
  }, [value]);

  const update = event => {
    const target = event.target;
    setInternalValue(target.value);
    valueRef.current = target.value;
    setTimeout(() => {
      if (valueRef.current === target.value) {
        onChange({ target: target });
      }
    }, delay || 300);
  };

  const clear = () => update({ target: { value: '' } });
  const showClearButton = !!internalValue || !!showClearWhenEmpty;
  const handleClearButtonClick = internalValue ? clear : onClearFiltered;

  return (
    <TextField
      variant="outlined"
      slotProps={{
        input: {
          sx: {
            '& .MuiInputAdornment-positionStart': {
              marginRight: 0.5
            },
            '& .MuiInputAdornment-positionEnd': {
              marginLeft: 0.5
            },
            '& .MuiOutlinedInput-input': {
              paddingLeft: '0 !important'
            },
            '& .MuiOutlinedInput-input::placeholder': {
              textOverflow: 'clip'
            }
          },
          startAdornment: (
            <InputAdornment position="start">
              <IconButton onClick={onClickPowerSearch} style={{ padding: 5 }} size="large">
                <img alt="serach" src="img/client-search.png" style={{ height: 20 }} />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: showClearButton ? (
            <InputAdornment position="end">
              <IconButton onClick={handleClearButtonClick} edge="end" style={{ padding: 3 }} size="small">
                <ClearIcon fontSize="inherit" />
              </IconButton>
            </InputAdornment>
          ) : (
            undefined
          ),
          style: {
            borderRadius: 12,
            paddingLeft: 0,
            font: 'inherit'
          }
        }
      }}
      onChange={update}
      value={internalValue}
      {...rest}
    />
  );
};

export default ClientSearchField;
